import React from "react";
import { Button } from "antd";
import { FilterButtonProps } from "./types";

export const FilterButton: React.FC<FilterButtonProps> = ({
  label,
  count,
  isActive,
  onClick,
  variant = "default",
}) => {
  return (
    <Button
      type={isActive ? "primary" : "default"}
      size="small"
      danger={variant === "critical" && isActive}
      onClick={onClick}
      className={`filter-button ${isActive ? "active" : ""} variant-${variant}`}
    >
      {label} ({count})
    </Button>
  );
};
